import { vars } from "@pancakeswap/ui/css/vars.css";
export var lightColors = vars.colors;
export var darkColors = vars.colors;
